import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    workspaceId: '',
    name: '',
    FromName: '',
    FromVersion: '',
    dataSourceItem: getDefaultAsyncWrapperObj(),
    createDataSource: getDefaultAsyncWrapperObj(),
    updateDataSource: getDefaultAsyncWrapperObj(),
    parameterList: [],
    streamList: [],
};
// Action Types
const createDataSourceOverridePrefix = 'createDataSourceOverride';
export const createDataSourceOverrideActionTypes = {
    LOAD: `${createDataSourceOverridePrefix}/LOAD`,
    LOADING: `${createDataSourceOverridePrefix}/LOADING`,
    LOADED: `${createDataSourceOverridePrefix}/LOADED`,
};
const updateDataSourceOverridePrefix = 'updateDataSourceOverride';
export const updateDataSourceOverrideActionTypes = {
    LOAD: `${updateDataSourceOverridePrefix}/LOAD`,
    LOADING: `${updateDataSourceOverridePrefix}/LOADING`,
    LOADED: `${updateDataSourceOverridePrefix}/LOADED`,
};
export const CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION = `${updateDataSourceOverridePrefix}/CLEAR_REQUEST`;
export const createDataSourceOverrideConstants = {
    SetCreateDataSource: `${createDataSourceOverridePrefix}/SetCreateDataSource`,
};
const setCreateDataSource = (state, actionResult) => {
    return {
        ...state,
        createDataSource: actionResult.payload,
    };
};
export function SetCreateDataSource(createDataSource) {
    return {
        type: createDataSourceOverrideConstants.SetCreateDataSource,
        payload: createDataSource.createDataSource,
    };
}
// Action Creator
/////////////////////////////////////////////////////////////
export const createDataSource = (workspaceId, dataSourceConfiguration) => {
    return {
        type: createDataSourceOverrideActionTypes.LOAD,
        payload: dataSourceConfiguration,
    };
};
export const creatingDataSource = () => {
    return {
        type: createDataSourceOverrideActionTypes.LOADING,
        payload: {},
    };
};
export const createdDataSource = (createDataSource) => {
    return {
        type: createDataSourceOverrideActionTypes.LOADED,
        payload: {
            createDataSource,
        },
    };
};
export const updateDataSource = (workspaceId, dataSourceConfiguration, baseOnVersion) => {
    return {
        type: updateDataSourceOverrideActionTypes.LOAD,
        payload: dataSourceConfiguration,
    };
};
export const updatingDataSource = () => {
    return {
        type: updateDataSourceOverrideActionTypes.LOADING,
        payload: {},
    };
};
export const updatedDataSource = (updateDataSource) => {
    return {
        type: updateDataSourceOverrideActionTypes.LOADED,
        payload: {
            updateDataSource,
        },
    };
};
export const clearDataSourceOverrideUpdateRequest = () => {
    return {
        type: CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION,
    };
};
// Reducer
export const dataSourceCreateReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case createDataSourceOverrideConstants.SetCreateDataSource:
            return setCreateDataSource(state, action);
        ////////////// LOADING ///////////////
        case createDataSourceOverrideActionTypes.LOADING:
            return {
                ...state,
                createDataSource: {
                    ...state.createDataSource,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case updateDataSourceOverrideActionTypes.LOADING:
            return {
                ...state,
                updateDataSource: {
                    ...state.updateDataSource,
                    status: AsyncRequestStatus.Pending,
                },
            };
        ///////////// LOADED /////////////////////
        case createDataSourceOverrideActionTypes.LOADED:
            return {
                ...state,
                createDataSource: {
                    ...state.createDataSource,
                    data: action.payload.createDataSource.data,
                    status: !!action.payload.createDataSource.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
                    error: action.payload.createDataSource.error,
                },
            };
        case updateDataSourceOverrideActionTypes.LOADED:
            return {
                ...state,
                updateDataSource: {
                    ...state.updateDataSource,
                    data: action.payload.updateDataSource.data,
                    status: !!action.payload.updateDataSource.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
                    error: action.payload.updateDataSource.error,
                },
            };
        case CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION:
            return {
                ...state,
                updateDataSource: getDefaultAsyncWrapperObj(),
            };
        default:
            return state;
    }
};
export default dataSourceCreateReducer;

//# sourceMappingURL=DataSourceCreateContainer.ducks.js.map
